module.exports = __webpack_public_path__ + "img/btn-swiper-play-on-control-02-m.7447ab8b.svg";